import React from 'react';
import logo from './logo.svg';
import './App.css';
import Player from './Player';
import { instruments, evaluationMidi } from './data';
import { line, intersectionSpace, scrollToRef } from './layout';

const Evaluation = () => {
	const topRef = React.useRef(null);
	const violinRef = React.useRef(null);
	const fluteRef = React.useRef(null);
	const instrumentRefs = [violinRef, fluteRef];

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', padding: '24px' }}>
				<h1>
					The control-synthesis approach for making expressive and controllable neural music synthesizers -
					Evaluation
				</h1>
				{line}
			</div>
			<div
				style={{
					margin: 'auto',
					display: 'flex',
					flexDirection: 'column',
					padding: '16px',
					justifyContent: 'center',
				}}
			>
				<div>
					<h2 ref={topRef}>Page index</h2>

					<ul>
						{[
							{ ref: violinRef, title: 'Violin' },
							{ ref: fluteRef, title: 'Flute' },
						].map((section) => (
							<h3 style={{ cursor: 'pointer' }} onClick={() => scrollToRef(section.ref)}>
								{'➤ ' + section.title}
							</h3>
						))}
					</ul>
				</div>
				{intersectionSpace}

				{instruments.map((ins, instrument_index) => (
					<React.Fragment key={ins.id}>
						<h2 ref={instrumentRefs[instrument_index]}>{ins.displayName}</h2>
						{line}
						<hr></hr>

						<Player
							title={'Training data excerpt'}
							midiFilePath={' '}
							audioFilePath={process.env.PUBLIC_URL + `/audio/${ins.id}/` + 'target.wav'}
						></Player>
						{evaluationMidi.map(
							(mf) =>
								!mf.hide && (
									<div style={{ marginTop: 10, marginBottom: 20 }} key={mf.displayName}>
										<Player
											title={mf.displayName}
											midiFilePath={process.env.PUBLIC_URL + '/midi/' + mf.fileName}
											audioFilePath={
												mf.audioFileName
													? process.env.PUBLIC_URL + `/audio/${ins.id}/` + mf.audioFileName
													: process.env.PUBLIC_URL +
													  `/audio/${ins.id}/` +
													  mf.fileName +
													  '_generated_performance.wav'
											}
										></Player>
									</div>
								)
						)}
						{intersectionSpace}
					</React.Fragment>
				))}

				<h2 style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => scrollToRef(topRef)}>
					Back to index ☝
				</h2>
			</div>
		</>
	);
};

export default Evaluation;
